import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GiftCardState } from './gift-card.states';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace GiftCardSelectors {
    export const selectGiftCardState = createFeatureSelector<GiftCardState>('gift-card');

    export const getCard = createSelector(selectGiftCardState, (state) => state.giftCard);
    export const getForm = createSelector(selectGiftCardState, (state) => state.giftCardForm);
    export const getCustomize = createSelector(selectGiftCardState, (state) => state.customizeSelected);
    export const getType = createSelector(selectGiftCardState, (state) => state.giftCardType);
    export const getBothGiftCards = createSelector(selectGiftCardState, (state) => state.giftCards);
    export const showBalance = createSelector(selectGiftCardState, (state) => state.showBalance);

    export const getGiftCardSaved = createSelector(selectGiftCardState, (state) => state.giftCardForm.giftCardSaved);

    export const getCardPrices = createSelector(selectGiftCardState, (state) => state.giftCardPrices);

    export const getSelectedGiftCardPrice = createSelector(selectGiftCardState, (state) => {
        return state.giftCardPrices.find((price) => price?.sku?.toString() === state.giftCardForm?.sku);
    });

    export const getCardTotal = createSelector(selectGiftCardState, (state) => state.giftCardTotal);
    export const getCardTransactions = createSelector(selectGiftCardState, (state) => state.giftCardTransactions);
    export const addedShopCart = createSelector(selectGiftCardState, (state) => state.addedToCart);

    export const getLoadingStatus = createSelector(selectGiftCardState, (state) => state.isLoading);
    export const getSuccess = createSelector(selectGiftCardState, (state) => state.isSuccess);
    export const getError = createSelector(selectGiftCardState, (state) => state.error);
}
